import {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import {checkBlockExecution} from '../../../store/actions/blockResultActions';
import {LAST_RESULT_KEY} from '../constants';

export function useLoadResult(
  uid: string | undefined,
  resultId: string | null | undefined,
  load: boolean = true
): any {
  /*
   * If resultId is provided, try to load that specific result ID, otherwise load the last result.
   */
  const dispatch = useDispatch();
  /*
   * TODO - implement loading
   */

  useEffect(() => {
    if (!load) {
      return;
    }

    if (uid && !resultId) {
      dispatch(checkBlockExecution(uid, LAST_RESULT_KEY, 0));
    } else if (uid && resultId) {
      dispatch(checkBlockExecution(uid, resultId, 0));
    }
  }, []);
}
